import CustomTooltip from "controls/global/custom-tooltip";
import React from "react";
import { fontSize } from "theme/defaultStyle";
import StyledInfoIcon from "theme/icons/StyledInfoIcon";

// The theme sets tooltips to 14px and MUI caps them at 300px, which wraps this one-line
// message onto three lines. Both are overridden here only, leaving every other tooltip in
// the pricing grid alone.
const collateralTooltipStyle = {
  fontSize: fontSize.small,
  maxWidth: "none",
  whiteSpace: "nowrap",
};

type Props = {
  primaryLoanProduct?: string;
  primaryLoanPolicyNumber?: string;
};

// Composed defensively: the primary loan details come from the API alongside the
// IsCollateral flag, so either part can legitimately be missing on older records.
export const getCollateralTooltip = (
  primaryLoanProduct?: string,
  primaryLoanPolicyNumber?: string
) => {
  if (!primaryLoanProduct) return "Collateral Mortgage";
  if (!primaryLoanPolicyNumber)
    return `Collateral Mortgage to ${primaryLoanProduct}`;

  return `Collateral Mortgage to ${primaryLoanProduct} [${primaryLoanPolicyNumber}]`;
};

// Shown after the product name in the pricing grid to mark a jacket as a Collateral
// Mortgage and name the primary loan policy it is attached to.
const CollateralMortgageIndicator = ({
  primaryLoanProduct,
  primaryLoanPolicyNumber,
}: Props) => (
  <CustomTooltip
    title={getCollateralTooltip(primaryLoanProduct, primaryLoanPolicyNumber)}
    placement="top"
    aria-label="collateral-mortgage-info"
    arrow
    componentsProps={{ tooltip: { sx: collateralTooltipStyle } }}
  >
    <StyledInfoIcon fontSize="small" />
  </CustomTooltip>
);

export default CollateralMortgageIndicator;
